export default "__VITE_ASSET__Caf4TMHY__"